import '../css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeLogId, checkLogin } from '../../store';
import { SyncLoader } from "react-spinners";
import Message from '../common/message';

import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

function Network() {
    let dark = useSelector((state) => { return state.Darkmode.value });

    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    const [data, setData] = useState([])

    const [createModal, setCreateModal] = useState(false)
    const [updateModal, setUpdateModal] = useState(false)
    const [clickId, setClickId] = useState([])

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    useEffect(() => {
        UpgradeData()
    }, [reload])

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/wallet-network', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                console.log(tmp)
                setData(tmp?.data?.network ?? [])
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    return (
        <div className='main'>
            <Message message={message} />
            {createModal && (<CreateModal darkname={darkname} setModal={setCreateModal} setReload={setReload} />)}
            {updateModal && (<UpdateModal darkname={darkname} setModal={setUpdateModal} clickId={clickId} setReload={setReload} />)}
            <div className={`main-box ${darkname}`}>
                <div className='member-1'>
                    <div className='modal-btn' onClick={() => setCreateModal(true)}>등록</div>
                </div>
                <div className={`member-2 ${darkname}`}>
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "5%", minWidth: "50px" }}>no.</div>
                        <div style={{ width: "5%", minWidth: "150px" }}>네트워크 이름</div>
                        <div style={{ width: "5%", minWidth: "120px" }}>네트워크 심볼</div>
                        <div style={{ width: "5%", minWidth: "120px" }}>메인코인 심볼</div>
                        <div style={{ width: "5%", minWidth: "100px" }}>네트워크ID</div>
                        <div style={{ width: "5%", minWidth: "50px" }}>체인ID</div>
                        <div style={{ width: "5%", minWidth: "140px" }}>RPC http URL</div>
                        <div style={{ width: "5%", minWidth: "140px" }}>RPC ws URL</div>
                        <div style={{ width: "5%", minWidth: "140px" }}>Scan URL</div>
                        <div style={{ width: "5%", minWidth: "140px" }}>BlockExplorer</div>
                        <div style={{ width: "5%", minWidth: "200px" }}>Icon URL</div>
                        <div style={{ width: "5%", minWidth: "100px" }}>활성/비활성</div>
                        <div style={{ width: "5%", minWidth: "150px" }}>비고</div>
                    </div>
                    <div className='table-body' style={{ minHeight: "600px" }}>
                        {
                            spinner
                                ?
                                <div className='spinner-modal'>
                                    <SyncLoader color="#003577" />
                                </div>
                                :
                                data.length === 0
                                    ?
                                    <div className='data-nofound'>
                                        <img src='/img/img_nofound.png'></img>
                                        <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                        <p>NO RECORDS FOUND</p>
                                    </div>
                                    :
                                    <>
                                        {
                                            data.map(function (a, i) {
                                                return (
                                                    <MemberItem key={i} item={a} darkname={darkname} dark={dark} setUpdateModal={setUpdateModal} setClickId={setClickId} setReload={setReload} />
                                                )
                                            })
                                        }
                                    </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, darkname, dark, setUpdateModal, setClickId, setReload }) {
    const onClickData = () => {
        setClickId(item);
        setUpdateModal(true)
    }

    const onSubmitDelete = async () => {
        if (window.confirm("삭제하시겠습니까?")) {
            await axios.post(process.env.REACT_APP_API + "/api/wallet-network/delete", {
                no: item.no
            }, {
                // headers: { 'Content-Type': 'multipart/form-data' },
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setReload(e => !e)
                }
                else {
                    // setMessage({ msg: "등록에 실패했습니다." })
                }
            }).catch(error => {
                console.error(error);
            });
        }
    }

    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className='td' style={{ width: "5%", minWidth: "50px" }}>{item.no}</div>
                <div className='td' style={{ width: "5%", minWidth: "150px" }}>
                    <div className="table-overflow-hidden">
                        {item.name}
                    </div>
                </div>
                <div className='td' style={{ width: "5%", minWidth: "120px" }}>
                    <div className="table-overflow-hidden">
                        {item.symbol}
                    </div>
                </div>

                <div className='td' style={{ width: "5%", minWidth: "120px" }}>
                    <div className="table-overflow-hidden">
                        {item.currency}
                    </div>
                </div>

                <div className='td' style={{ width: "5%", minWidth: "100px" }}>
                    <div className="table-overflow-hidden">
                        {item.networkId}
                    </div>
                </div>

                <div className='td' style={{ width: "5%", minWidth: "50px" }}>
                    <div className="table-overflow-hidden">
                        {item.chainId}
                    </div>
                </div>

                <div className='td' style={{ width: "5%", minWidth: "140px" }}>
                    <div className="table-overflow-hidden">
                        {item.rpcApiHttpUrl}
                    </div>
                </div>

                <div className='td' style={{ width: "5%", minWidth: "140px" }}>
                    <div className="table-overflow-hidden">
                        {item.rpcApiWsUrl}
                    </div>
                </div>

                <div className='td' style={{ width: "5%", minWidth: "140px" }}>
                    <div className="table-overflow-hidden">
                        {item.scanApiUrl}
                    </div>
                </div>

                <div className='td' style={{ width: "5%", minWidth: "140px" }}>
                    <div className="table-overflow-hidden">
                        {item.blockexpUrl}
                    </div>
                </div>

                <div className='td' style={{ width: "5%", minWidth: "200px" }}>
                    <div className="table-overflow-hidden" style={{ paddingRight: "5px" }}>
                        {item.icon}
                    </div>
                    <img src={item.icon} style={{ width: "28px" }} />
                </div>

                <div className='td' style={{ width: "5%", minWidth: "100px" }}>
                    <div className="table-overflow-hidden">
                        {item.isActive == 1 ? "활성화" : "비활성화"}
                    </div>
                </div>

                <div className='td' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', width: "5%", minWidth: "150px" }}>
                    <div className="upgrade-btn" onClick={() => onClickData()} style={{ backgroundColor: "#003577", color: "#fff" }}>수정</div>
                    <div className="upgrade-btn" onClick={() => onSubmitDelete()}>삭제</div>
                </div>
            </div>
        </>
    )
}

function InfoIcon({ content, tooltipId }) {
    // 재사용 툴팁 아이콘
    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span
                data-tooltip-id={tooltipId}
                data-tooltip-content={content}
                style={{ cursor: "pointer", fontSize: "16px" }}
            >
                <FontAwesomeIcon icon={faCircleInfo} style={{ color: "#b3b3b3" }} />
            </span>
            <Tooltip
                id={tooltipId}
                place="top"  // 툴팁 위치 (상단)
                effect="solid"
                style={{
                    backgroundColor: "#000",  // **완전한 흰색**
                    color: "#fff",  // 검은색 글씨
                    border: "1px solid gray",  // 회색 보더
                    padding: "8px",  // 내부 여백
                    borderRadius: "5px",  // 둥근 모서리
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",  // 그림자 효과 추가
                    opacity: 1,  // **완전히 불투명하게 설정**
                    backdropFilter: "none", // 블러 효과 방지
                    WebkitBackdropFilter: "none" // 사파리 블러 방지
                }}
            />
        </div>
    );
}

function CreateModal({ darkname, setModal, setReload, dataList }) {
    const [formData, setFormData] = useState({
        networkGroup: "solana",
        networkName: "",
        networkSymbol: "",
        tokenName: "",
        tokenSymbol: "",
        tokenAddress: "0",
        tokenDecimals: "0",
        tokenDescription: "",
        tokenType: "",
        tokenScanApi: "",
        tokenBlockExplorer: "",
        tokenIcon: "",
        isActive: "1",
    });

    // 아이콘 파일 & 미리보기
    const [iconFile, setIconFile] = useState(null);
    const [iconPreview, setIconPreview] = useState(null);
    const hiddenFileInputRef = useRef(null);

    // 소문자 강제 입력 및 영문 알파벳만 허용
    const forceLowerCaseAlpha = (value) => {
        return value.toLowerCase().replace(/[^a-z]/g, "");
    };

    // URL 형식 검증
    const isHttpUrl = (url) => /^https?:\/\//i.test(url);
    const isWsUrl = (url) => /^wss?:\/\//i.test(url);

    // input 변경 처리
    const onChangeInput = (e) => {
        let { name, value } = e.target;
        if (["networkName", "networkSymbol", "tokenSymbol"].includes(name)) {
            value = forceLowerCaseAlpha(value);
        }
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // select 변경 처리
    const onChangeSelect = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // 아이콘 업로드 버튼 -> 숨겨진 file input 클릭
    const handleIconUploadClick = () => {
        if (hiddenFileInputRef.current) {
            hiddenFileInputRef.current.click();
        }
    };

    // 파일 선택 처리
    const handleIconFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIconFile(file);
        // 미리보기
        const previewUrl = URL.createObjectURL(file);
        setIconPreview(previewUrl);
        // tokenIcon에도 파일명(혹은 임의의 URL) 세팅
        setFormData((prev) => ({ ...prev, tokenIcon: file.name }));
    };

    // X 버튼: 업로드된 아이콘 제거
    const handleRemoveIcon = () => {
        setIconFile(null);
        setIconPreview(null);
        setFormData((prev) => ({ ...prev, tokenIcon: "" }));

        // ★ 파일 input 초기화
        if (hiddenFileInputRef.current) {
            hiddenFileInputRef.current.value = "";
        }
    };

    // 제출 (multipart/form-data)
    const onSubmit = async () => {
        if (!formData.networkName) {
            alert("네트워크 이름을 입력해주세요.");
            return;
        }
        if (!formData.tokenSymbol) {
            alert("메인코인 심볼을 입력해주세요.");
            return;
        }

        try {
            // 파일 + 텍스트 필드를 함께 전송하기 위해 FormData 사용
            const form = new FormData();
            // 텍스트 필드들
            form.append("networkGroup", formData.networkGroup);
            form.append("name", formData.networkName);
            form.append("description", formData.tokenName);
            form.append("symbol", formData.networkSymbol);
            form.append("networkId", formData.tokenAddress);
            form.append("chainId", formData.tokenDecimals);
            form.append("rpcApiHttpUrl", formData.tokenDescription);
            form.append("rpcApiWsUrl", formData.tokenType);
            form.append("scanApiUrl", formData.tokenScanApi);
            form.append("blockexpUrl", formData.tokenBlockExplorer);
            form.append("isActive", formData.isActive);
            form.append("currency", formData.tokenSymbol);

            // 파일이 있으면 append
            if (iconFile) {
                form.append("file", iconFile);
            }

            // multipart/form-data 헤더
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/wallet-network/regist",
                form,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response.data?.code === 1000) {
                setModal(false);
                setReload((prev) => !prev);
            } else {
                alert(response.data?.msg || "등록에 실패했습니다.");
            }
        } catch (error) {
            console.error(error);
            alert("네트워크 등록 중 오류가 발생했습니다.");
        }
    };

    // 빨간 글씨 안내문 (http)
    const renderHttpWarning = (value) => {
        if (value?.length > 0 && !isHttpUrl(value)) {
            return (
                <span style={{ paddingLeft: "5px", color: "red" }}>
                    http:// 또는 https:// 로 시작해주세요
                </span>
            );
        }
        return null;
    };

    // 빨간 글씨 안내문 (ws)
    const renderWsWarning = (value) => {
        if (value?.length > 0 && !isWsUrl(value)) {
            return (
                <span style={{ paddingLeft: "5px", color: "red" }}>
                    ws:// 또는 wss:// 로 시작해주세요
                </span>
            );
        }
        return null;
    };

    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: "600px" }}>
                    <div className="modal-1-header">네트워크 등록</div>

                    {/* 상단부: 7개 필드 => 2열 Grid */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            columnGap: "10px",
                            rowGap: "0px",
                        }}
                    >
                        {/* 네트워크 그룹 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                네트워크 그룹 선택
                            </div>
                            <div className={`password-1 ${darkname}`} style={{ padding: "0", paddingRight: "5px" }}>
                                <select
                                    name="networkGroup"
                                    value={formData.networkGroup}
                                    onChange={onChangeSelect}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        padding: "7px 10px",
                                        height: "34px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="solana">solana</option>
                                    <option value="bsc">bsc</option>
                                    <option value="ton">ton</option>
                                </select>
                            </div>
                        </div>

                        {/* 표시 활성/비활성 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                표시 활성/비활성
                                <InfoIcon
                                    tooltipId="tooltip-active"
                                    content="미니앱 지갑에서 표시할지 여부"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`} style={{ padding: "0", paddingRight: "5px" }}>
                                <select
                                    name="isActive"
                                    value={formData.isActive}
                                    onChange={onChangeSelect}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        padding: "7px 10px",
                                        height: "34px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="1">활성</option>
                                    <option value="0">비활성</option>
                                </select>
                            </div>
                        </div>

                        {/* 네트워크 이름 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">네트워크 이름</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="networkName"
                                    value={formData.networkName}
                                    onChange={onChangeInput}
                                    placeholder="네트워크 이름 (영문 소문자)"
                                />
                            </div>
                        </div>

                        {/* 네트워크 심볼 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                네트워크 심볼
                                <InfoIcon
                                    tooltipId="tooltip-networkSymbol"
                                    content="미니앱 지갑에서 표시될 네트워크 심볼 (예: solana, bsc, ton)"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="networkSymbol"
                                    value={formData.networkSymbol}
                                    onChange={onChangeInput}
                                    placeholder="네트워크 심볼 (영문 소문자)"
                                />
                            </div>
                        </div>

                        {/* 설명 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">설명</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenName"
                                    value={formData.tokenName}
                                    onChange={onChangeInput}
                                    placeholder="네트워크 설명"
                                />
                            </div>
                        </div>

                        {/* 메인코인 심볼 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                메인코인 심볼
                                <InfoIcon
                                    tooltipId="tooltip-tokenSymbol"
                                    content="해당 네트워크의 코인 심볼 (sol, bnb, ton 등)"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenSymbol"
                                    value={formData.tokenSymbol}
                                    onChange={onChangeInput}
                                    placeholder="메인코인 심볼 (영문 소문자)"
                                />
                            </div>
                        </div>

                        {/* 네트워크 ID */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">네트워크 ID</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenAddress"
                                    value={formData.tokenAddress}
                                    onChange={onChangeInput}
                                    placeholder="네트워크 ID (기본값 0)"
                                />
                            </div>
                        </div>

                        {/* 체인 ID */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">체인 ID</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenDecimals"
                                    value={formData.tokenDecimals}
                                    onChange={onChangeInput}
                                    placeholder="체인 ID (기본값 0)"
                                />
                            </div>
                        </div>
                    </div>

                    {/* (2) 하단부: 5개 필드 => 1열 Grid */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            rowGap: "0px",
                            marginBottom: "30px",
                        }}
                    >
                        {/* RPC API http URL */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                RPC API http URL
                                <InfoIcon
                                    tooltipId="tooltip-rpcHttp"
                                    content="미니앱 지갑에서 사용할 RPC 중개서버 http URL"
                                />
                                {renderHttpWarning(formData.tokenDescription)}
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenDescription"
                                    value={formData.tokenDescription}
                                    onChange={onChangeInput}
                                    placeholder="http:// 또는 https:// 로 시작"
                                />
                            </div>
                        </div>

                        {/* RPC API ws URL */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                RPC API ws URL
                                <InfoIcon
                                    tooltipId="tooltip-rpcWs"
                                    content="미니앱 지갑에서 사용할 RPC 중개서버 웹소켓 URL"
                                />
                                {renderWsWarning(formData.tokenType)}
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenType"
                                    value={formData.tokenType}
                                    onChange={onChangeInput}
                                    placeholder="ws:// 또는 wss:// 로 시작"
                                />
                            </div>
                        </div>

                        {/* Scan API URL */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                Scan API URL
                                <InfoIcon
                                    tooltipId="tooltip-scanApi"
                                    content="bsc, ton 등 일부 네트워크에서 전송 트랜잭션 확인에 필요한 URL"
                                />
                                {renderHttpWarning(formData.tokenScanApi)}
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenScanApi"
                                    value={formData.tokenScanApi}
                                    onChange={onChangeInput}
                                    placeholder="http:// 또는 https:// 로 시작"
                                />
                            </div>
                        </div>

                        {/* BlockExplorer URL */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                BlockExplorer URL
                                <InfoIcon
                                    tooltipId="tooltip-blockexp"
                                    content="미니앱 지갑에서 전송내용 상세보기 링크로 사용"
                                />
                                {renderHttpWarning(formData.tokenBlockExplorer)}
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenBlockExplorer"
                                    value={formData.tokenBlockExplorer}
                                    onChange={onChangeInput}
                                    placeholder="http:// 또는 https:// 로 시작"
                                />
                            </div>
                        </div>

                        {/* Icon URL + 아이콘 업로드 + 미리보기 + X 버튼 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                Icon URL
                                <InfoIcon
                                    tooltipId="tooltip-icon"
                                    content="미니앱 지갑에서 표시될 네트워크 아이콘 URL"
                                />
                            </div>
                            <div
                                className={`password-1 ${darkname}`}
                                style={{ display: "flex", alignItems: "center", gap: "8px" }}
                            >
                                <input
                                    name="tokenIcon"
                                    value={formData.tokenIcon}
                                    onChange={onChangeInput}
                                    placeholder="http:// 또는 https:// 또는 Local path"
                                    style={{ flex: "1" }}
                                />
                                <div
                                    onClick={handleIconUploadClick}
                                    style={{
                                        backgroundColor: "#eee",
                                        borderRadius: "5px",
                                        padding: "5px 10px",
                                        cursor: "pointer",
                                    }}
                                >
                                    아이콘 업로드
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={hiddenFileInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleIconFileChange}
                                />
                                {/* 미리보기 + X 버튼 */}
                                {iconPreview && (
                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <img
                                            src={iconPreview}
                                            alt="아이콘 미리보기"
                                            style={{
                                                width: "32px",
                                                height: "32px",
                                                objectFit: "contain",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                        />
                                        <button
                                            onClick={handleRemoveIcon}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                color: "red",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            X
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="modal-btn-box">
                        <div className={`modal-btn ${darkname}`} onClick={onSubmit}>
                            등록
                        </div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setModal(false)}>
                            취소
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function UpdateModal({ darkname, setModal, clickId, setReload }) {
    // (1) 기존 아이콘 URL (DB에서 가져온 경로)
    const [originalIcon] = useState(clickId.icon || "");

    // (2) 초기에 미리보기 = DB에서 가져온 아이콘 URL
    const [iconPreview, setIconPreview] = useState(clickId.icon || "");

    // (3) 실제 새로 업로드한 파일(없으면 null)
    const [iconFile, setIconFile] = useState(null);

    // 숨겨진 file input ref
    const hiddenFileInputRef = useRef(null);

    // (4) formData 초기값 (DB값 활용)
    const [formData, setFormData] = useState({
        networkGroup: clickId.networkGroup || "solana",
        networkName: clickId.name || "",
        networkSymbol: clickId.symbol || "",
        tokenName: clickId.description || "",
        tokenSymbol: clickId.currency || "",
        tokenAddress: clickId.networkId || "0",
        tokenDecimals: clickId.chainId || "0",
        tokenDescription: clickId.rpcApiHttpUrl || "",
        tokenType: clickId.rpcApiWsUrl || "",
        tokenScanApi: clickId.scanApiUrl || "",
        tokenBlockExplorer: clickId.blockexpUrl || "",
        tokenIcon: clickId.icon || "",
        isActive: String(clickId.isActive) || "1",
    });

    // 소문자 & 영문 알파벳만 허용
    const forceLowerCaseAlpha = (value) => {
        return value.toLowerCase().replace(/[^a-z]/g, "");
    };
    const isHttpUrl = (url) => /^https?:\/\//i.test(url);
    const isWsUrl = (url) => /^wss?:\/\//i.test(url);

    // (5) input(onChange)
    const onChangeInput = (e) => {
        let { name, value } = e.target;
        // 특정 필드는 영문 소문자만
        if (["networkName", "tokenSymbol", "networkSymbol"].includes(name)) {
            value = forceLowerCaseAlpha(value);
        }
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // (6) select(onChange)
    const onChangeSelect = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // (7) "아이콘 업로드" 버튼 -> 숨겨진 input 클릭
    const handleIconUploadClick = () => {
        if (hiddenFileInputRef.current) {
            hiddenFileInputRef.current.click();
        }
    };

    // (8) 파일 선택
    const handleIconFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIconFile(file);
        // 미리보기
        const previewUrl = URL.createObjectURL(file);
        setIconPreview(previewUrl);

        // formData.tokenIcon에 파일명(또는 임의값) 반영
        setFormData((prev) => ({ ...prev, tokenIcon: file.name }));
    };

    // (9) X 버튼: 새 업로드 취소 -> 원본 아이콘 복원
    const handleRemoveIcon = () => {
        // file input 값 초기화
        if (hiddenFileInputRef.current) {
            hiddenFileInputRef.current.value = "";
        }
        setIconFile(null);
        setIconPreview(originalIcon);
        setFormData((prev) => ({ ...prev, tokenIcon: originalIcon }));
    };

    // (10) 수정 (multipart/form-data 전송)
    const onSubmit = async () => {
        try {
            // FormData 생성
            const form = new FormData();
            // 백엔드 파라미터명에 맞게 append
            form.append("no", clickId.no);
            form.append("networkGroup", formData.networkGroup);
            form.append("name", formData.networkName);
            form.append("description", formData.tokenName);
            form.append("symbol", formData.networkSymbol);
            form.append("networkId", formData.tokenAddress);
            form.append("chainId", formData.tokenDecimals);
            form.append("rpcApiHttpUrl", formData.tokenDescription);
            form.append("rpcApiWsUrl", formData.tokenType);
            form.append("scanApiUrl", formData.tokenScanApi);
            form.append("blockexpUrl", formData.tokenBlockExplorer);
            form.append("isActive", formData.isActive);
            form.append("currency", formData.tokenSymbol);

            // 파일이 있으면 업로드
            if (iconFile) {
                form.append("file", iconFile);
            }

            const response = await axios.post(
                process.env.REACT_APP_API + "/api/wallet-network/update",
                form,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response.data?.code === 1000) {
                setModal(false);
                setReload((prev) => !prev);
            } else {
                alert(response.data?.msg || "수정에 실패했습니다.");
            }
        } catch (error) {
            console.error(error);
            alert("토큰 수정 중 오류가 발생했습니다.");
        }
    };

    // (11) 유효성 검증 (http, ws 등) => 필요 시 render
    const renderHttpWarning = (value) => {
        if (value?.length > 0 && !isHttpUrl(value)) {
            return (
                <span style={{ paddingLeft: "5px", color: "red" }}>
                    http:// 또는 https:// 을 작성해주세요
                </span>
            );
        }
        return null;
    };
    const renderWsWarning = (value) => {
        if (value?.length > 0 && !isWsUrl(value)) {
            return (
                <span style={{ paddingLeft: "5px", color: "red" }}>
                    ws:// 또는 wss:// 로 시작해주세요
                </span>
            );
        }
        return null;
    };

    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: "600px" }}>
                    <div className="modal-1-header">네트워크 수정</div>

                    {/* 상단부: 2열 Grid */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            columnGap: "10px",
                            rowGap: "0px",
                        }}
                    >
                        {/* 네트워크 그룹 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">네트워크 그룹 선택</div>
                            <div className={`password-1 ${darkname}`} style={{ padding: "0", paddingRight: "5px" }}>
                                <select
                                    name="networkGroup"
                                    value={formData.networkGroup}
                                    onChange={onChangeSelect}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        padding: "7px 10px",
                                        height: "34px",
                                        borderRadius: "5px",
                                    }}
                                    disabled
                                >
                                    <option value="solana">solana</option>
                                    <option value="bsc">bsc</option>
                                    <option value="ton">ton</option>
                                </select>
                            </div>
                        </div>

                        {/* 표시 활성/비활성 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                표시 활성/비활성
                                <InfoIcon
                                    tooltipId="tooltip-active"
                                    content="미니앱 지갑에서 표시할지 여부"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`} style={{ padding: "0", paddingRight: "5px" }}>
                                <select
                                    name="isActive"
                                    value={formData.isActive}
                                    onChange={onChangeSelect}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        padding: "7px 10px",
                                        height: "34px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="1">활성</option>
                                    <option value="0">비활성</option>
                                </select>
                            </div>
                        </div>

                        {/* 네트워크 이름 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">네트워크 이름</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="networkName"
                                    value={formData.networkName}
                                    onChange={onChangeInput}
                                    placeholder="네트워크 이름 (영문 소문자)"
                                />
                            </div>
                        </div>

                        {/* 네트워크 심볼 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                네트워크 심볼
                                <InfoIcon
                                    tooltipId="tooltip-networkSymbol"
                                    content="미니앱 지갑에서 표시될 네트워크 심볼 (예: solana, bsc, ton)"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="networkSymbol"
                                    value={formData.networkSymbol}
                                    onChange={onChangeInput}
                                    placeholder="네트워크 심볼 (영문 소문자)"
                                />
                            </div>
                        </div>

                        {/* 설명 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">설명</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenName"
                                    value={formData.tokenName}
                                    onChange={onChangeInput}
                                    placeholder="네트워크 설명"
                                />
                            </div>
                        </div>

                        {/* 메인코인 심볼 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                메인코인 심볼
                                <InfoIcon
                                    tooltipId="tooltip-tokenSymbol"
                                    content="해당 네트워크의 코인 심볼 (sol, bnb, ton 등)"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenSymbol"
                                    value={formData.tokenSymbol}
                                    onChange={onChangeInput}
                                    placeholder="메인코인 심볼 (영문 소문자)"
                                />
                            </div>
                        </div>

                        {/* 네트워크 ID */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">네트워크 ID</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenAddress"
                                    value={formData.tokenAddress}
                                    onChange={onChangeInput}
                                    placeholder="네트워크 ID (기본값 0)"
                                />
                            </div>
                        </div>

                        {/* 체인 ID */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">체인 ID</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenDecimals"
                                    value={formData.tokenDecimals}
                                    onChange={onChangeInput}
                                    placeholder="체인 ID (기본값 0)"
                                />
                            </div>
                        </div>
                    </div>

                    {/* 하단부: 1열 Grid */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            rowGap: "0px",
                            marginBottom: "30px",
                        }}
                    >
                        {/* RPC API http URL */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                RPC API http URL
                                <InfoIcon
                                    tooltipId="tooltip-rpcHttp"
                                    content="미니앱 지갑에서 사용할 RPC 중개서버 http URL"
                                />
                                {renderHttpWarning(formData.tokenDescription)}
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenDescription"
                                    value={formData.tokenDescription}
                                    onChange={onChangeInput}
                                    placeholder="http:// 또는 https:// 로 시작"
                                />
                            </div>
                        </div>

                        {/* RPC API ws URL */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                RPC API ws URL
                                <InfoIcon
                                    tooltipId="tooltip-rpcWs"
                                    content="미니앱 지갑에서 사용할 RPC 중개서버 웹소켓 URL"
                                />
                                {renderWsWarning(formData.tokenType)}
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenType"
                                    value={formData.tokenType}
                                    onChange={onChangeInput}
                                    placeholder="ws:// 또는 wss:// 로 시작"
                                />
                            </div>
                        </div>

                        {/* Scan API URL */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                Scan API URL
                                <InfoIcon
                                    tooltipId="tooltip-scanApi"
                                    content="bsc, ton 등 일부 네트워크에서 전송 트랜잭션 확인에 필요한 URL"
                                />
                                {renderHttpWarning(formData.tokenScanApi)}
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenScanApi"
                                    value={formData.tokenScanApi}
                                    onChange={onChangeInput}
                                    placeholder="http:// 또는 https:// 로 시작"
                                />
                            </div>
                        </div>

                        {/* BlockExplorer URL */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                BlockExplorer URL
                                <InfoIcon
                                    tooltipId="tooltip-blockexp"
                                    content="미니앱 지갑에서 전송내용 상세보기 링크로 사용"
                                />
                                {renderHttpWarning(formData.tokenBlockExplorer)}
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenBlockExplorer"
                                    value={formData.tokenBlockExplorer}
                                    onChange={onChangeInput}
                                    placeholder="http:// 또는 https:// 로 시작"
                                />
                            </div>
                        </div>

                        {/* Icon URL + 아이콘 업로드 + 미리보기 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                Icon URL
                                <InfoIcon
                                    tooltipId="tooltip-icon"
                                    content="미니앱 지갑에서 표시될 네트워크 아이콘 URL"
                                />
                            </div>
                            <div
                                className={`password-1 ${darkname}`}
                                style={{ display: "flex", alignItems: "center", gap: "8px" }}
                            >
                                <input
                                    name="tokenIcon"
                                    value={formData.tokenIcon}
                                    onChange={onChangeInput}
                                    placeholder="http:// 또는 https:// 또는 Local path"
                                    style={{ flex: 1 }}
                                />
                                {/* 업로드 버튼 */}
                                <div
                                    onClick={() => hiddenFileInputRef.current.click()}
                                    style={{
                                        backgroundColor: "#eee",
                                        borderRadius: "5px",
                                        padding: "5px 10px",
                                        cursor: "pointer",
                                    }}
                                >
                                    아이콘 업로드
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={hiddenFileInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleIconFileChange}
                                />

                                {/* 미리보기 */}
                                {iconPreview && (
                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <img
                                            src={iconPreview}
                                            alt="아이콘 미리보기"
                                            style={{
                                                width: "32px",
                                                height: "32px",
                                                objectFit: "contain",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                        />
                                        {/* X 버튼은 '새로 업로드(iconFile)가 존재'할 때만 표시 */}
                                        {iconFile && (
                                            <button
                                                onClick={handleRemoveIcon}
                                                style={{
                                                    background: "none",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    color: "red",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                X
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="modal-btn-box">
                        <div className={`modal-btn ${darkname}`} onClick={onSubmit}>
                            수정
                        </div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setModal(false)}>
                            취소
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Network;